import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { Message } from 'element-ui';
/* 创建axios实例 */
const service = axios.create({
  baseURL: "/portal", //** 基础地址 要请求的url前缀  
  timeout: 30000, // 请求超时时间
  headers: {
    'Authorization': 'Authorization'
  }
});

//http request 拦截器
service.interceptors.request.use((config: AxiosRequestConfig) => {
      //....
      return config
    },
    error => {
      return Promise.reject(error);
    }
  );
  
//http response 拦截器
service.interceptors.response.use((response: AxiosResponse) => {
      if(response.data.code !== 'HTTP200'){
        Message({message: response.data.msg, type: 'error'});
      }
      return response.data;
    },
    error => {
      if (error.response){
        switch (error.response.status){
          case 401:
            console.log(error.response.status)
        }
      }
      
      return Promise.reject(error.response.data)
    }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
 
 export function get(url = '', params={}){
  return new Promise((resolve, reject) => {
    axios.get(url,{
      params: params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
 }

 /**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
  export function post(url='', data = {}){
    return new Promise((resolve, reject) => {
      axios.post(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
    })
  }

export default service;
